// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2976":"4df90602","3283":"dc543b7a","3925":"4df90602","4357":"4df90602","4942":"864b7478","5244":"10f9fa15","5782":"e8dd1be9"}[chunkId] + ".chunk.css";
};